<template>
  <div id="app" :class="{'side-menu-is-active': isMenuOpen, }" class="has-navbar-top">
    <!-- <BottomNavbar></BottomNavbar> -->

    <!-- :class="{ 'hidden-top-navbar' : !isNavOpen && $route.name !== 'events',
    'is-fixed-top': $route.name === 'home'}"-->
    <nav
      class="navbar has-border-bottom is-fixed-top"
      role="main navigation"
      style="top: 0; left:0; "
    >
      <!-- :class="{'hidden-top-navbar': !$store.state.ui.isNavOpen}" -->
      <!-- 'hidden-top-navbar': !$store.state.ui.isNavOpen -->
      <div class="container">
        <div class="navbar-brand">
          <BackButton v-if="($route.name !== 'home' && $route.name !== 'events')"></BackButton>
          <div class="navbar-item" v-else>
            <div
              class="navbar-button has-icon has-text-grey-dark"
              @click="$store.commit('ui/TOGGLE_MENU', !$store.state.ui.isMenuOpen)"
              @click.native="$analytics.logEvent('toggle_menu', { status: 'open'})"
            >
              <span class="icon" style="padding-top: 4px">
                <i
                  class="mdi mdi-24px"
                  :class="{ 'mdi-menu': !$store.state.ui.isMenuOpen, 'mdi-close': $store.state.ui.isMenuOpen}"
                ></i>
              </span>
              <!-- <span class="is-size-7 mt-0 is-inline has-text-weight-medium">{{ $t('ui.menu') }}</span> -->
            </div>
          </div>

          <!-- <transition name="fade" mode="out-in"> -->
          <!-- v-if="$route.name === 'home' || $route.name === 'event-view' || $route.name === 'venue-view'" -->
          <router-link
            v-if="$route.name !== 'home'"
            :to="{name: 'home', params: { cityName: $store.state.user.userCity }}"
            @click.native="$analytics.logEvent('hit_logo', { page_name: $route.name })"
            class="navbar-item"
          >
            <img src="@/assets/hafta8-logo.png" alt="hafta8-logo" style="height: 20px" />
          </router-link>
          <a
            @click.native="$analytics.logEvent('hit_logo', { page_name: $route.name })"
            v-else
            href="/"
            class="navbar-item"
          >
            <img src="@/assets/hafta8-logo.png" alt="hafta8-logo" style="height: 20px" />
          </a>
          <!-- v-else-if="$route.name === 'events'" -->
          <div class="navbar-item" v-if="false">
            <p class="has-text-black-ter is-size-18px">{{ $t(`evType.${$route.params.slug}`) }}</p>
          </div>
          <!-- <div class="navbar-item" v-else>
              <p class="has-text-black-ter is-size-18px">{{ $t(`evType.${$route.name}`) }}</p>
          </div>-->
          <!-- </transition> -->

          <!-- <div class="navbar-item"> -->
          <router-link
            class="navbar-item ml-auto"
            @click.native="$analytics.logEvent('hit_nav_button', { page_name: $route.name, button_name: 'search_btn'})"
            :to="{name: 'search'}"
          >
            <span class="icon has-text-grey-dark">
              <i class="mdi mdi-24px mdi-magnify"></i>
            </span>
          </router-link>
          <router-link
            class="navbar-item"
            @click.native="$analytics.logEvent('hit_nav_button', { page_name: $route.name, button_name: 'heart_btn'})"
            :to="{name: 'favorite', params: {slug: $store.state.user.authUser ? $store.state.user.authUser.uid : ''}}"
          >
            <span class="icon has-text-grey-dark">
              <i class="mdi mdi-24px mdi-star-outline"></i>
            </span>
          </router-link>
          <router-link
            class="navbar-item"
            @click.native="$analytics.logEvent('hit_nav_button', { page_name: $route.name, button_name: 'account_btn'})"
            :to="{name: 'user-profile', params: {slug:$store.state.user.authUser ? $store.state.user.authUser.uid : ''}}"
          >
            <span class="icon has-text-grey-dark">
              <i class="mdi mdi-24px mdi-account-outline"></i>
            </span>
          </router-link>

          <!-- <span class="is-size-7 mt-0 is-inline has-text-weight-medium">{{ $t('ui.menu') }}</span> -->
          <!-- </div> -->
        </div>
      </div>
    </nav>

    <!-- MENU OVERLAY -->
    <div
      class="menu-overlay"
      :class="{'has-no-opacity': !isMenuOpen}"
      @click="$store.commit('ui/TOGGLE_MENU', false); $analytics.logEvent('toggle_menu', { status: 'close'})"
      v-show="isMenuOpen"
    ></div>

    <!-- SIDE MENU -->
    <aside class="side-menu" :class="{'menu-is-active': isMenuOpen}">
      <!-- <div style="height: 100px; width: 65vw; position: relative" class="has-background-grey">Menu</div> -->
      <MenuComp></MenuComp>
    </aside>

    <!-- add to home screen  -->
    <div
      class="section is-hidden-desktop has-background-danger"
      style="padding: 8px 16px 0 16px;"
      v-if="false"
    >
      <div class="columns is-mobile">
        <div class="column is-7 has-text-weight-semibold content-justified-center">
          <p class="is-size-7 has-text-white-ter">
            <span class="has-text-weight-bold">{{ $store.state.appName }}</span> uygulamasını ana ekrana ekleyebilir dilediğinde hızlıca ulaşabilirsin
          </p>
        </div>
        <div class="column content-justified-center">
          <div class="buttons">
            <a
              class="button has-text-weight-semibold has-text-black-bis is-rounded is-warning is-small is-fullwidth"
              @click="addToHomeScreen"
            >Ekle</a>
            <a
              class="button has-text-weight-semibold has-text-black-ter is-outlined is-rounded is-small is-fullwidth"
              @click="isInstallPromptPostponed = true"
            >Daha Sonra</a>
          </div>
        </div>
      </div>
    </div>
    <!-- ./add to home screen  -->

    <!-- MAIN VIEW -->
    <keep-alive :include="['home', 'event', 'event-view', 'venue', 'venue-view', 'events']" max="5">
      <router-view :key="$route.fullPath" />
    </keep-alive>
    <!-- <vue-progress-bar></vue-progress-bar> -->

    <CookiesAlert style="position: fixed; bottom: 4px; left: 4px; right: 4px; z-index: 35000"></CookiesAlert>

    <!-- sign in to continue -->
    <SigninModal></SigninModal>

    <!-- <BuyModalSeat></BuyModalSeat> -->

    <!-- <PaymentModal :key="paymentModalKey"></PaymentModal> -->
    <!-- ./MODALs -->
  </div>
</template>

<script>
const SigninModal = () =>
  import(/* webpackChunkName: "modal" */ "@/components/auth/SigninModal.vue");

import MenuComp from "@/components/main/MenuComp";
import BackButton from "@/components/ui/BackButton";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { scrollNav } from "@/mixins/scroll";
import { getCookie } from "@/utilities/cookie";
import {messaging} from "@/fireinit";

export default {
  metaInfo() {
    return {
      title: process.env.VUE_APP_NAME,
      htmlAttrs: {
        lang: this.$i18n.locale
      }
    };
  },
  components: {
    MenuComp,
    CookiesAlert: () => import("@/components/survey/CookiesAlert"),
    BackButton,
    SigninModal
  },
  mixins: [scrollNav],
  data() {
    return {
      scrollValue: 0,
      isInstallPromptPostponed: false,
      deferredPrompt: null,
      isPWAinBrowser: true,
      // REFRESH APP
      refreshing: false,
      registration: null,
      updateExists: false
    };
  },

  watch: {
    user() {
      if (
        this.$store.state.user.userDoc.username === "" &&
        !this.$store.state.user.userDoc.isAnonymous
      ) {
        this.$router.push({ name: "choose-username" });
      }
    },
    isMenuOpen(val) {
      val
        ? document.getElementsByTagName("html")[0].classList.add("is-clipped")
        : document
            .getElementsByTagName("html")[0]
            .classList.remove("is-clipped");
    }
  },
  mounted() {
    // Remove landing icon on page load
    // const elem = document.querySelector("#landing");
    // if (elem) elem.parentNode.removeChild(elem);
    // this.$Progress.finish();
  },
  computed: {
    ...mapGetters({
      isNavOpen: "ui/isNavOpen",
      isMenuOpen: "ui/isMenuOpen",
      user: "user/userDoc",
      isAppInstalled: "ui/isAppInstalled",
      // isRouteLocked: "ui/isRouteLocked"
    }),
    menuOffsetTop() {
      return window.pageYOffset + "px";
    }
  },
  methods: {
    ...mapActions({
      goBack: "ui/goBack",
      deleteIDB: "appData/deleteIDB"
    }),
    ...mapMutations({
      // toggleNav: "ui/SET_HIDE_BOTTOM_NAVBAR",
      setAppInstalled: "ui/SET_APP_INSTALLED"
    }),
    // setPopstateListener
    addToHomeScreen() {
      // todo: show add to home screen prompt
      // Show the prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      let vm = this;
      this.deferredPrompt.userChoice.then(choiceResult => {
        console.log("app install choice result", choiceResult);
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
          vm.setAppInstalled(true);
          vm.isInstallPromptPostponed = true;
        } else {
          vm.setAppInstalled(false);
          console.log("User dismissed the A2HS prompt");
        }
        this.deferredPrompt = null;
      });
    },
    showRefreshUI(e) {
      // TODO remove this function call
      this.$store.dispatch("appData/deleteIDB", "nereyelaDB");

      this.deleteIDB()

      console.log("show refresh ui");
      this.registration = e.detail;
      // this.updateExists = true;
      this.$buefy.snackbar.open({
        message: "Yeni versiyon mevcut",
        type: "is-success",
        position: "is-top",
        actionText: this.$t("ui.refresh"),
        indefinite: true,
        onAction: () => {
          this.refreshApp();
        }
      });
    },
    refreshApp() {
      console.log("refresh app func runs");
      // this.updateExists = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    }
  },
  created() {
    messaging.onMessage(payload => {
      console.log("onMessage :", payload);
    });

    // set user city; default is Ankara
    // this.$store.commit("user/SET_USER_CITY", 'ankara')


    this.$store.dispatch("appData/prepareFavoritesList");

    if (process.env.NODE_ENV === "development") {
      console.log("App.vue is created");
    }

    this.$store.dispatch("appData/fetchEventTypes");

    // get user device language
    // console.log("navigator lang", navigator.language);
    // if (navigator.language !== "tr") {
    //   this.$i18n.locale = "en";
    // }

    // notify new version is avaliable
    // this.showRefreshUI();
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });

    const lastRefreshTime = JSON.parse(localStorage.getItem("lastRefreshTime"));
    // const firstVisit = JSON.parse(localStorage.getItem("firstVisit"));
    // console.log('first visit type', typeof firstVisit);

    navigator.serviceWorker.addEventListener("controllerchange", async () => {
      // only refresh page if is not first visit
      if (this.refreshing || !lastRefreshTime) return;
      this.refreshing = true;

      await this.$store.dispatch("deleteIDB", { dbName: "nereyelaDB" });
      console.log("RELOADING MY MIND");
      window.location.reload();
    });

    // if navigator is online refresh localStorage
    const isOnline = window.navigator.onLine;
    if (process.env.NODE_ENV === "development") {
      console.log("is navigator online", isOnline);
    }
    if (isOnline) {
      // if refresh time is graeter than 6 hours refresh localStorage
      localStorage.setItem("lastRefreshTime", new Date().getTime());
    }

    // TODO get city from cookie
    const userCity = getCookie("UCTY");

    if (userCity) {
      this.$store.dispatch("user/setUserCity", userCity);
    } else {
      this.$store.dispatch("user/setUserCity", this.$store.state.user.userCity);
    }
    // this.$store.dispatch("user/setUserCity", this.$store.state.user.userCity);

    // TODO: craft it to have better experience
    // If user hasn't choosed a username don't let her go anywhere than choose-username view
    // if (this.user && (this.user.username === "" && !this.user.isAnonymous)) {
    //   this.$router.push({ name: "choose-username" });
    // }

    // let vm = this;

    // Get GeoLocation
    // if (navigator.geolocation) {
    //   return;
    //   navigator.geolocation.getCurrentPosition(showPosition);
    // } else {
    //   console.log("error on geolocation fetching it by ip");
    // }
    // function showPosition(position) {
    //   console.log(position);
    // }
    // ./Get GeoLocation

  }
};
</script>

